module.exports = __webpack_public_path__ + "static/media/light-theme-idiling-duration.89378659.svg";